import React, { createContext, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useUser from '../hooks/useUser';
import { clearTokenFromLocalStorage } from '../utils/auth';
import { buildLoginUrl } from '../utils/nextParam';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { user, loading, error, setUser } = useUser();

  const value = {
    user,
    loading,
    error,
    setUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    clearTokenFromLocalStorage();
    // #140539 (AC3): giữ lại nơi người dùng ĐỊNH VÀO trên URL (`?next=`), không chỉ trong `state`.
    // `LoginPage` đăng nhập xong tải lại cả trang nên `state` trong bộ nhớ của react-router mất
    // sạch — `state` giữ nguyên ở đây chỉ để không phá chỗ nào khác đang đọc nó.
    return (
      <Navigate to={buildLoginUrl(location)} state={{ from: location }} replace />
    );
  }

  return children;
};

export const RequireAdmin = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user || user.role !== 'ADMIN') {
    return <Navigate to="/error" state={{ from: location }} replace />;
  }

  return children;
}; 